import { render, staticRenderFns } from "./WhatsAppVincular.vue?vue&type=template&id=526e6111&scoped=true"
import script from "./WhatsAppVincular.vue?vue&type=script&lang=js"
export * from "./WhatsAppVincular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526e6111",
  null
  
)

export default component.exports